import { Link, useNavigate, useLocation } from 'react-router-dom'
// ** Reactstrap Imports
import { Card, CardBody, CardTitle, CardText, Button, Form } from 'reactstrap'
// ** Styles
import '@styles/react/pages/page-authentication.scss'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { verifyPasswordReset } from './Components/Datatable/store/action'
import toast from "react-hot-toast";
import useJwt from '@src/auth/jwt/useJwt'
import { useState, useEffect } from 'react'
import { Spinner } from 'reactstrap'
const TwoStepsBasic = () => {

  const { register, handleSubmit, formState: { errors }, reset, control } = useForm({});
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const dispatch = useDispatch()
  const searchParams = new URLSearchParams(location.search);
  const email = searchParams.get('email');

  const onSubmit = (input, e) => {
    setLoading(true);
    e.preventDefault();
    
    // Combine all inputs into the token
    const token =
      input.num1 +
      input.num2 +
      input.num3 +
      input.num4 +
      input.num5 +
      input.num6;

    // Submit the token without triggering focus events
    dispatch(verifyPasswordReset({ key: token, email }))
      .then(({ data }) => {
        setLoading(false);
        navigate(`/reset-password?email=${data?.user?.email}&key=${token}&token=${data?.user?.token}`);
        toast.success("Email verified Successfully!");
      })
      .catch(({ response }) => {
        setLoading(false);
        const errors = response?.data?.message;
        toast.error(errors);
      });
  };
      

  const handelResendCode = (e) => {
    e.preventDefault()
    useJwt.forgotPassword({ email })
      .then(({ data }) => {
        if (data.status) {
          toast.success("Email verification code has been sent!")
        } else {
          toast.error("Invalid Email")
        }
      }).catch(function ({ response }) {
        let errors = response?.data?.message
        toast.error(errors)
      })
  }

  // Reset form and focus the first input field
  const handleReset = () => {
    reset(); // Clears the form fields

    // Set timeout to ensure that reset has been completed before focusing the first field
    setTimeout(() => {
      document.getElementById('num1')?.focus(); // Focuses the first input field after reset
    }, 50);
  }

  // Function to handle focus on the next field when typing
  const handleFocus = (e, index) => {
    const { value } = e.target;
    if (/^\d$/.test(value)) {
      const nextInput = document.getElementById(`num${index + 1}`);
      if (nextInput) {
        nextInput.focus();
      }
    } else {
      e.target.value = '';
    }
  }

  // Function to handle focus on previous field when backspacing
  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && !e.target.value) {
      const prevInput = document.getElementById(`num${index - 1}`);
      if (prevInput) {
        prevInput.focus();
      }
    }
  }

  // Function to handle input (to manage transition and typing)
  const handleInput = (e, index) => {
    const { value } = e.target;
    if (/^\d$/.test(value)) {
      // Move to the next input field if the current input is valid
      const nextInput = document.getElementById(`num${index + 1}`);
      if (nextInput) {
        nextInput.focus();
      }
    } else {
      e.target.value = ''; // Remove any invalid characters
    }
  }

  useEffect(() => {
    // Focus the first input when the page is loaded
    document.getElementById('num1')?.focus();
  }, []); // Focus on mount

  return (
    <div className='auth-wrapper auth-basic px-2'>
      <div className='auth-inner my-2'>
        <Card className='mb-0'>
          <CardBody>
            <CardTitle tag='h2' className='fw-bolder mb-1'>
              <h2 className='brand-text text-primary text-center mt-2'>Two Step Verification</h2>
            </CardTitle>
            <CardText className='mb-75'>
              We sent a verification code to your email. Enter the code in the field below.
            </CardText>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <h6>Type your 6 digit security code</h6>
              <div className="auth-input-wrapper d-flex align-items-center justify-content-between" onPaste={(e) => { e.preventDefault(); toast.error("Pasting is disabled. Please type the code."); }}>
                {[...Array(6)].map((_, index) => (
                  <input
                    key={index}
                    maxLength="1"
                    id={`num${index + 1}`}
                    name={`num${index + 1}`}
                    {...register(`num${index + 1}`, { required: true })}
                    className="auth-input height-50 text-center numeral-mask mx-25 mb-1 form-control"
                    onChange={(e) => handleFocus(e, index + 1)} // Use handleFocus for next field focus
                    onKeyDown={(e) => handleBackspace(e, index + 1)} // Use handleBackspace for previous field focus
                    onInput={(e) => handleInput(e, index + 1)} // Use handleInput for handling input values
                  />
                ))}
              </div>
              <Button block color='primary' type='submit'>
                {loading ? <Spinner color='white' size='sm' /> : ''}
                <span className='ml-50'>Submit</span>
              </Button>
              {/* Reset button */}
              <Button style={{ marginTop: '5px' }} block color='secondary' type='button' onClick={handleReset}>
                Clear
              </Button>
            </Form>
            <p className='text-center mt-2'>
              <span>Didn’t get the code?</span>{' '}
              <a href='/' onClick={(e) => handelResendCode(e)}>
                Resend
              </a>{' '}
            </p>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default TwoStepsBasic
